import { createEffect } from 'effector';
import { AppPanels } from 'src/app/providers/RouteProvider/lib/routeConfig';
import { setActivePanel } from 'src/entity/ActivePanel';

export const openFinalPanelAfterPostFx = createEffect(
  () => {
    setActivePanel(AppPanels.FINAL);
  }
);
